// export const baseUrl = "http://localhost:8000/api";
// export const imageUrl = "http://localhost:8000/storage/media/";

export const baseUrl = "https://api.ootycrops.com/api";
export const imageUrl = "https://api.ootycrops.com/storage/media/";
